import { render, staticRenderFns } from "./SendMail.vue?vue&type=template&id=3266c55a&scoped=true&"
import script from "./SendMail.vue?vue&type=script&lang=ts&"
export * from "./SendMail.vue?vue&type=script&lang=ts&"
import style0 from "./SendMail.vue?vue&type=style&index=0&id=3266c55a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3266c55a",
  null
  
)

export default component.exports